import React from 'react'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import Collapsible from '@jarvis.oddle/core/components/Collapsible'
import Divider from '@jarvis.oddle/core/components/Divider'
import Flex from '@jarvis.oddle/core/components/Flex'
import { H4, LinkText } from '@jarvis.oddle/core/components/Typo'

const StoreInformationSummary = ({
  show,
  numOfStores,
  onViewStoreClick
}: {
  show: boolean
  numOfStores: number
  onViewStoreClick: () => void
}): JSX.Element => {
  const { t } = React.useContext(TranslationContext)
  return (
    <Collapsible show={show}>
      <Divider />
      <Flex
        width='100%'
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
      >
        <H4 normalised bold>
          {t('_numOfStores_ Store(s) Available', { numOfStores })}
        </H4>
        <LinkText heading onClick={onViewStoreClick}>
          {t('View Store List')}
        </LinkText>
      </Flex>
    </Collapsible>
  )
}

export default StoreInformationSummary
